import styles from "./VersionUpdateDialog.module.css"
import Dialog from "./Dialog";
import { Each } from "../../common/Each";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { useContext, useState } from "react";
import MainContext from "../../common/MainContext";
import Button from "../Button";

const VersionUpdateDialog = ({ updateInfo, reload, isFirstView }) => {

    const [closed, setClosed] = useState(false);
    const context = useContext(MainContext);

    return (
        <Dialog style={{maxWidth: '600px'}} open={!!updateInfo && !!context.user && !context.user?.isAnonymous && !closed && !context.notificationPermissions } title={isFirstView ? `Nuova versione (${updateInfo?.version})` : `Aggiornamento disponibile (${updateInfo?.version})`} onClose={() => { }}
            showCloseButton={isFirstView}
            action={
                // Dialog expects a React node, not a config object. Render the button here.
                isFirstView ? (
                    <Button onClick={() => setClosed(true)}>{updateInfo.actionLabel || 'CHIUDI'}</Button>
                ) : (
                    <Button onClick={() => reload()}>AGGIORNA ORA</Button>
                )
            }>
            <div className={styles.content}>
                {updateInfo?.features &&
                    <div className={styles.features}>
                        <Each of={updateInfo.features} render={(feature, i) => (
                            <div key={i} className={styles.featureItem}>
                                <div className={styles.featureTitle}>{feature.title}</div>
                                <div className={styles.featureDesc}>
                                    <Markdown rehypePlugins={[rehypeRaw]}>
                                        {feature.description}
                                    </Markdown>
                                </div>

                            </div>
                        )} />
                    </div>}
            </div>
        </Dialog>
    )

}

export default VersionUpdateDialog;